<template>
  <div>
    <div class="rm4-card rm4-card--auto-height">
      <InputOverview :show-time="true"></InputOverview>
    </div>

    <div class="rm4-card">
      <div class="rm4-card__label">Confirmation</div>
      <div class="rm4-card__sub-label">
        Reservation confirmation will be sent to your email address
      </div>
      <div class="rm4-info-person-date-summary">
        <div>
          Reservation for <strong>{{ personLabel }}</strong>,
        </div>
        <div>
          <strong>{{ dateLabel }}</strong> at {{ $store.time }}h
        </div>
      </div>
      <div class="rm4-info-list">
        <div class="rm4-info-list__item">
          <div class="rm4-info-list__item__label">Email</div>
          <div class="rm4-info-list__item__value">{{ $store.email }}</div>
        </div>
        <div class="rm4-info-list__item">
          <div class="rm4-info-list__item__label">Name</div>
          <div class="rm4-info-list__item__value">{{ name }}</div>
        </div>
        <div class="rm4-info-list__item">
          <div class="rm4-info-list__item__label">Phone</div>
          <div class="rm4-info-list__item__value">{{ $store.phone }}</div>
        </div>
      </div>
      <div v-if="$store.isDrinkOnly" class="rm4-card__muted-label">
        Please note: your order is for Drinks only
      </div>

      <div v-show="$store.loading" class="rm4-loader"></div>
    </div>

    <div class="rm4-actions">
      <div class="rm4-button" @click="reset">Go to homepage</div>
    </div>

    <form
      ref="adyenForm"
      v-if="adyenFormAction"
      :action="adyenFormAction"
      method="post"
    >
      <template v-if="adyenFormInputs.length">
        <input
          v-for="(adyenInput, index) in adyenFormInputs"
          :key="index"
          :name="adyenInput.name"
          :type="adyenInput.type"
          :value="adyenInput.value"
        />
      </template>
    </form>

    <modal
      name="rm4-info-modal"
      :height="'auto'"
      :adaptive="true"
      :classes="'rm4-modal-content'"
    >
      <div class="rm4-modal-container rm4-modal-container--centered">
        <div class="rm4-modal-close" @click="$modal.hide('rm4-info-modal')">
          <span class="rm4-modal-close-icon">&#10005;</span>
        </div>
        <div class="text" v-html="modalData"></div>
        <button
          class="rm4-button rm4-button--primary rm4-mt-1"
          @click="$store.currentStep = $step.FIRST"
        >
          Back
        </button>
      </div>
    </modal>

    <modal
      name="rm4-not-complete-modal"
      :height="'auto'"
      :adaptive="true"
      :classes="'rm4-modal-content'"
    >
      <div class="rm4-modal-container">
        <div
          class="rm4-modal-close"
          @click="$modal.hide('rm4-not-complete-modal')"
        >
          <span class="rm4-modal-close-icon">&#10005;</span>
        </div>
        <div>
          Your reservation is NOT complete! Are you sure you want to move away
          from this step?
        </div>
        <div class="rm4-actions rm4-actions--modal">
          <div
            class="rm4-button rm4-button--tertiary"
            @click="$store.currentStep = $step.FOURTH"
          >
            Yes
          </div>
          <div
            class="rm4-button"
            @click="$modal.hide('rm4-not-complete-modal')"
          >
            No
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import InputOverview from "./InputOverview";

export default {
  name: "Confirm",
  components: { InputOverview },
  data: function() {
    return {
      adyenFormAction: null,
      adyenFormInputs: [],
      modalData: null,
      existingStep: 0
    };
  },
  mounted: function() {
    window.onbeforeunload = function() {
      return true;
    };
  },
  methods: {
    reset() {
      // Remove the beforeunload handler before navigating
      window.onbeforeunload = null;

      this.$store.date = new Date();
      this.$store.time = null;
      this.$store.frame = null;
      this.$store.frameConfig = [];
      this.$store.adults = 2;
      this.$store.kids = 0;
      this.$store.timeSlots = [];
      this.$store.email = null;
      this.$store.firstName = null;
      this.$store.lastName = null;
      this.$store.phone = null;
      this.$store.zipCode = null;
      this.$store.keepInformed = false;
      this.$store.loading = false;
      window.location.href = "/";
    },
    goTo(refName) {
      const element = this.$refs[refName];

      window.scrollTo({
        top: _.get(element, "offsetTop"),
        behavior: "smooth"
      });
    }
  },
  computed: {
    name: function() {
      return `${this.$store.firstName} ${this.$store.lastName}`;
    },
    personLabel: function() {
      return this.$store.adults + this.$store.kids + " persons";
    },
    dateLabel: function() {
      const dayName = moment(this.$store.date).isBetween(
        moment(),
        moment().add(6, "days"),
        "date",
        "[]"
      )
        ? this.dateFormatted()
        : "";

      return `${dayName} ${moment(this.$store.date).format("DD-MM-YYYY")}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.rm4-info-person-date-summary {
  text-align: center;
  padding: 0 0 16px;
  border-bottom: 1px solid #e6e6e6;
}

.rm4-info-list {
  padding-top: 16px;
  overflow: hidden;

  .rm4-info-list__item {
    display: flex;
    align-items: center;
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }

    .rm4-info-list__item__label {
      font-size: 16px;
      color: grey;
      text-align: right;
      min-width: 70px;
      margin-right: 32px;
    }

    .rm4-info-list__item__value {
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
}

.rm4-card__sub-label {
  a {
    color: #8a927c !important;
  }
}

.rm4-mt-1 {
  margin-top: 16px;
}

.rm4-mt-2 {
  margin-top: 32px;
}
</style>
